import React, { useEffect, useState } from "react";
import Card from "./card";
import { setCookie } from "../utils/utils";
import "./tdb-open.css";
import UserIcon from "../assets/testRide/userProfileIcon.svg";
import RefreshIcon from "../assets/testRide/refresh.svg";
import PosIcon from "../assets/testRide/pos-icon.svg";
import Icon from "../assets/blog/logoBlack.svg";
import BlueTag from "../assets/newPurchase/blueTag.svg";
import OfflineIcon from "../assets/testRide/offline-icon.svg";
import { Drawer } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CircularProgress } from "@mui/material";
import { useHistory } from "react-router";
import { makeAPICall } from "../services/apiService";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { deleteCookie } from "../utils/utils";
import { offlinepaymentLogo } from "../assets/images/assetsAll";
import axios from 'axios';

const TdbOpen = (props) => {
  console.log("domain", window?.location?.href?.includes('service'))
  const [cookie, setCookieState] = useState("");
  // const [showLogout, setLogout] = useState(false);
  const [openModal, setModal] = useState(false);
  const [modalMsg, setMsg] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isRideStarted, setIsRideStarted] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showToast, setShowToast] = useState("none");
  const [toastMessage, setToastMessage] = useState("");
  const [eligibleManageOrders, setEligibleManageOrders] = useState(false)
  const [showPosOption, setShowPosOption] = useState(false);
  const [showOfflineLoanOption, setShowOfflineLoanOption] = useState(false);
  const [showExchangeOption, setShowExchangeOption] = useState(false);
  const [eligibleOrderDiscount, setEligibleOrderDiscount] = useState(false);
  const [eligibleOfflinePayment, setEligibleOfflinePayment] = useState(false)
  const openMenu = Boolean(anchorEl);
  const [dateArr, setdateArr] = useState([]);
  const [selectedDate, setSelectedDate] = useState(0);
  const [dateValue, setDateValue] = useState(new Date());
  const history = useHistory();
  const [list, setList] = useState([]);
  const bcDetails = JSON.parse(localStorage.getItem("bcUserDetails"));
  const [checkEligibility, setCheckEligibility] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [cookieDomain, setCookieDomain] = useState('')
  //secret key
  const dummy_id = 'iuytrtyuioliuhgfghjkjhgvfhjkGHJMNBJHGTFDCV';

  let generalData = JSON.parse(localStorage.getItem('generalData'));

  useEffect(() => {
    sessionStorage.removeItem('user_details')
    // getPosIngressForBc();
    getAllEligibilityIngressForBc();
    getLoginUserDetails();
    localStorage.setItem("futPastDate", new Date());
    deleteCookie(["payu_transaction_id", "from_purchase_flow"]);
    fetchSDCEligibility();
  }, []);

  useEffect(() => {
    var day = dateValue; //new Date(dateValue);
    let arr = [];
    for (var i = 0; i < 7; i++) {
      var nextDay = new Date(day);
      nextDay.setDate(day.getDate() + i);
      arr.push(nextDay);
    }
    setdateArr(arr);
  }, [dateValue]);

  const getLoginUserDetails = () => {
    let config = {
      method: "get",
      url: `/api/user/get-user-details`,
    };
    makeAPICall(config)
      .then((response) => {
        if (response && response.data) {
          localStorage.setItem("bcUserDetails", JSON.stringify(response.data));
        }
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  };

  const getPosIngressForBc = () => {
    let config = {
      method: "get",
      url: `/api/pos/isPosAvailable`,
    };
    makeAPICall(config)
      .then((response) => {
        if (response && response?.data && response?.data?.isEligiblePos) {
          setShowPosOption(true);
        }
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  };

  const getAllEligibilityIngressForBc = () => {
    let config = {
      method: "get",
      url: `/api/loan/checkEligibility`,
    };
    makeAPICall(config)
      .then((response) => {
        if (response && response?.data) {
          setShowOfflineLoanOption(response?.data?.isEligibleOfflineFinancing || false);
          setEligibleOrderDiscount(response?.data?.isEligibleOrderDiscount || false);
          setEligibleOfflinePayment(response?.data?.isEligibleOfflinePayment || false)
          setEligibleManageOrders(response?.data?.isEligiblePos || false);
        }
        // setEligibleOfflinePayment(true)
        if (response && response?.data && response?.data?.isEligibleExchange) {
          setShowExchangeOption(true);
        }
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeMenu = () => {
    setAnchorEl(null);
    setModal(true);
    setSelectedType("logout");
    setMsg("Are you sure you want to Logout?");
  };

  const completeLogout = () => {
    if (getCookie("pos-machine-id")) {
      let config = {
        method: "put",
        url: `api/pos/validatePosMachineId`,
        data: {
          pos_device_id: getCookie("pos-machine-id"),
          status: "LOG_OUT",
        },
      };

      makeAPICall(config)
        .then((resp) => {
          if (resp && resp.data.status === "SUCCESSFUL") {
            logoutApiCall();
          }
        })
        .catch((err) => {
          logoutApiCall();
        });
    } else {
      logoutApiCall();
    }

    setAnchorEl(null);
  };

  const logoutApiCall = () => {
    let logoutconfig = {
      method: "put",
      url: `/api/user/logout`,
      headers: {
        oem_auth_token: getCookie("oem_auth_token"),
      },
      data: {},
    };
    makeAPICall(logoutconfig)
      .then((data) => {
        console.log("Sucess ", data);
        history.push("/phoneNumber");
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  };

  const pad2 = (n) => {
    return (n < 10 ? "0" : "") + n;
  };

  const getTestRideList = (user_cookie, date) => {
    let today = "";
    if (date) {
      today = new Date(date);
    } else {
      today = new Date();
    }
    today =
      today.getFullYear() +
      "-" +
      pad2(today.getMonth() + 1) +
      "-" +
      pad2(today.getDate());
    setIsRideStarted(false);
    let config = {
      method: "put",
      url: `api/ride/lists`,
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        currdate: today,
        "oem-auth-token": user_cookie,
      },
      data: {},
    };
    makeAPICall(config)
      .then((res) => {
        let response = res?.data?.data;
        setShowLoader(false);
        response = response?.map((item) => {
          if (item.status === "STARTED") {
            item.order = 1;
            setIsRideStarted(true);
          } else if (item.status === "BOOKED") {
            item.order = 2;
          } else if (item.status === "COMPLETED") {
            item.order = 3;
          } else {
            item.order = 4;
          }
          return item;
        });
        response = response?.sort((a, b) => a.order - b.order);
        response = response?.sort((b, c) => {
          if (b.order === c.order) {
            return new Date(b.start_time) - new Date(c.start_time);
          }
        });
        setList(response);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log("ride listing error ", err);
        // if (parseInt(err?.response?.status) === 403 ) {
        //     setToastMessage('You are unauthorized!');
        //     setShowToast('block');
        //     setTimeout(() => {
        //         setShowToast('none');
        //         // completeLogout();
        //     }, 3000);
        // }
      });
  };

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const fetchSDCEligibility = () => {
    setTimeout(() => {
      setCheckEligibility(
        JSON.parse(localStorage.getItem("env_const"))?.showSDC == "true"
          ? true
          : false
      );
    }, 1 * 1000);
  };

  useEffect(() => {
    let userCookie = getCookie("oem_auth_token");
    if (userCookie) getTestRideList(userCookie);
    else history.push("/phoneNumber");

    setCookieState(userCookie);
  }, []);

  const handleModal = (type, ride_id, obj) => {
    setModal(true);
    setSelectedType(type);
    setSelectedId(ride_id);
    setSelectedItem(obj);
    if (type === "start") {
      setMsg("Are you sure you want to start test ride?");
    } else if (type === "map") {
      setMsg("Are you sure you want to navigate to customer's location?");
    } else {
      setMsg("Are you sure you want to end test ride?");
    }
  };
  const handleRide = () => {
    setModal(false);
    if (selectedType === "start") {
      startRide(selectedItem);
    } else if (selectedType === "map") {
      window.location = `https://www.google.com/maps/search/${selectedItem.latitude},${selectedItem.longitude}`;
    } else if (selectedType === "logout") {
      completeLogout();
    } else {
      completeRide(selectedId);
    }
  };

  const startRide = (ride_obj) => {
    if (cookie) {
      let config = {
        method: "put",
        url: `api/ride/startRide`,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          "test-ride-id": ride_obj.uuid,
        },
        data: {},
      };
      makeAPICall(config)
        .then((res) => {
          let response = res?.data;
          if (response?.status === "SUCCESSFUL") {
            let userCookie = getCookie("oem_auth_token");
            getTestRideList(userCookie);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else history.push("/phoneNumber");
  };

  const completeRide = (ride_id) => {
    if (cookie) {
      let config = {
        method: "put",
        url: `api/ride/completeRide`,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          "test-ride-id": ride_id,
        },
        data: {},
      };
      makeAPICall(config)
        .then((res) => {
          let response = res?.data;
          if (response?.status === "SUCCESSFUL") {
            let userCookie = getCookie("oem_auth_token");
            getTestRideList(userCookie);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else history.push("/phoneNumber");
  };
  const nameList = list?.map((ridelist) => {
    return (
      <Card
        ridelist={ridelist}
        handleModal={handleModal}
        startRide={startRide}
        completeRide={completeRide}
        isRideStarted={isRideStarted}
      />
    );
  });
  const dateConversion = (date, isFirstDate) => {
    let day = new Date(date);
    const month = day.toLocaleString("default", { month: "short" });
    return (
      <div className={` ${isFirstDate}`}>
        <div className="active-date">
          <div className="today">{pad2(day.getDate())}</div>
          <div className="mid-border"></div>
          <div className="month">{month}</div>
        </div>
      </div>
    );
  };

  const onCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDateClick = (item, index) => {
    setSelectedDate(index);
    setShowLoader(true);
    let userCookie = getCookie("oem_auth_token");
    getTestRideList(userCookie, item);
    localStorage.setItem("futPastDate", item);
  };
  const refreshPage = () => {
    setDateValue(new Date());
    setSelectedDate(0);
    setShowLoader(true);
    let userCookie = getCookie("oem_auth_token");
    getTestRideList(userCookie);
    localStorage.setItem("futPastDate", new Date());
  };

  const renderDateItem = (item, index) => {
    const isFirstDate = index == selectedDate ? "current" : "";
    return (
      <div
        className="ul-second-container"
        onClick={(e) => handleDateClick(item, index)}
      >
        {dateConversion(item, isFirstDate)}
      </div>
    );
  };


  const handleDateChange = (newDate) => {
    setDateValue(newDate);
    handleDateClick(newDate, 0);
    localStorage.setItem("futPastDate", newDate);
  };

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
    return false;
  };
  const getElectricUrl = () => {
    let config = {
      method: 'get',
      url: `api/loan/getElectricRedirectUrl`,
    };
    makeAPICall(config)
      .then((res) => {
        if (res?.data) {
          setRedirectUrl(res?.data?.ELECTRIC_REDIRECT_URL);
          setCookieDomain(res?.data?.DOMAIN)
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const setPhoneNumber = () => {
    const body = getPhoneCookiePostBody();
    axios.post('/set-cookie', body);
  };
  const getPhoneCookiePostBody = () => {
    return {
      cookieValue: base64Encode(generalData?.phoneNumber),
      cookieKey: 'phone_number',
    };
  }
  const base64Encode = (data, dummy_id) => {
    const encoder = new TextEncoder();
    // Combine dummy_id with the original data
    const saltedData = dummy_id + data;
    const bytes = encoder.encode(saltedData);
    let binaryString = '';
    bytes.forEach(byte => binaryString += String.fromCharCode(byte));
    return btoa(binaryString);
  };


  useEffect(() => {
    getElectricUrl()
    setPhoneNumber()
  }, [])
  return (
    <div className="main-div">
      <div className="header-bar">
        <div className="header-text"></div>
        <div className="icon-container">
          <img
            src={UserIcon}
            alt="userIcon"
            onClick={handleClick}
            style={{ "pointer-events": "all" }}
          />
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={onCloseMenu}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={onCloseMenu} className="menuUI">
            Logged in as {bcDetails?.name}
          </MenuItem>
          <MenuItem onClick={closeMenu} className="menuUI">
            Logout
          </MenuItem>
        </Menu>
      </div>
      <div className="redirect-container">
        {/* {showPosOption && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/pos-machineId")}
          >
            <img src={PosIcon} />
            POS Machine
          </button>
        )} */}
        {showOfflineLoanOption && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/offline-finance-search")}
          >
            <div className="icon-cont">
              <img src={OfflineIcon} />
            </div>
            Offline financing
          </button>
        )}

        {eligibleManageOrders && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/manage-orders")}
          >
            <div className="icon-cont">
              <img src={Icon} style={{ width: "24px" }} />
            </div>
            Manage Orders
          </button>
        )}
        {eligibleOrderDiscount && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/apply-coupon-search")}
          >
            <div className="icon-cont">
              <img src={BlueTag} style={{ width: "20px" }} />
            </div>
            Apply coupon
          </button>
        )}
        {eligibleOfflinePayment && (
          <button
            className="redirect_btn"
            onClick={() => history.push({
              pathname: "/apply-coupon-search",
              search: "?offinepayment=true"
            })}
          >
            <div className="icon-cont">
              <img src={offlinepaymentLogo} style={{ width: "20px" }} />
            </div>
            Offline payment
          </button>)}
        {showExchangeOption && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/search-exchange")}
          >
            <div className="icon-cont">
              <img src={Icon} style={{ width: "24px" }} />
            </div>
            Scooter Exchange
          </button>
        )}

        {checkEligibility && (
          <button
            className="redirect_btn"
            onClick={() => history.push("/check-scooter-eligibility")}
          >
            <div className="icon-cont">
              <img src={Icon} style={{ width: "36px" }} />
            </div>
            Check availability
          </button>
        )}

        {(window?.location?.href?.includes('service') &&
          <button
            className="redirect_btn"
            onClick={() => {
              window.location.href = `${redirectUrl}?sessionId=${base64Encode(generalData?.phoneNumber, dummy_id)}`
            }}
          >
            <div className="icon-cont">
              <img src={Icon} style={{ width: "36px" }} />
            </div>
            Manage Attendance
          </button>
        )}
      </div>
      <Drawer
        anchor={"bottom"}
        open={openModal}
        onClose={() => setModal(false)}
        PaperProps={{
          style: {
            borderRadius: 0,
          },
        }}
      >
        <div className="bc-modal-container">
          <div className="model-heading-container">{modalMsg}</div>
          <div className="btn-container">
            <button onClick={() => setModal(false)} className="cancel-btn">
              Back
            </button>
            <button onClick={() => handleRide()} className="confirm-btn">
              Yes
            </button>
          </div>
        </div>
      </Drawer>
    </div>
  );
  // return (
  //     <div className="main-div">
  //         <div className="header">
  //             <div className="header-text">Open TR Bookings</div>
  //             <div> <img src={RefreshIcon} className="refreshIcon" alt="userIcon" onClick={refreshPage} style={{ "pointer-events": "all" }} /></div>
  //             <div> <img src={UserIcon} alt="userIcon" onClick={handleClick} style={{ "pointer-events": "all" }} /></div>
  //             <Menu
  //                 id="basic-menu"
  //                 anchorEl={anchorEl}
  //                 open={openMenu}
  //                 onClose={onCloseMenu}
  //                 transformOrigin={{ horizontal: 'right', vertical: 'top' }}
  //                 anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}

  //             >
  //                 {showPosOption &&
  //                 <MenuItem onClick={() => history.push('/pos-machineId')} className="menuUI">
  //                     POS Machine
  //                 </MenuItem>
  //                 }
  //                 {showOfflineLoanOption &&
  //                 <MenuItem onClick={() => history.push('/offline-finance-search')} className="menuUI">
  //                     Offline Financing
  //                 </MenuItem>
  //                 }
  //                {<MenuItem onClick={() => history.push('/customer-search')} className="menuUI">
  //                     Customer Search
  //                 </MenuItem>
  //                 }
  //                 <MenuItem onClick={closeMenu} className="menuUI">
  //                     Logout
  //                 </MenuItem>
  //             </Menu>
  //         </div>
  //         <div className="ul-first-container">
  //             {
  //                 dateArr?.map((item, index) => renderDateItem(item, index))
  //              }

  //         </div>
  //        { showLoader ?
  //         <div className="grey-text cirpro"> <CircularProgress color="inherit"/></div>
  //         :
  //         <>
  //         <div className='bookigs-list-parent'>
  //                  <div className="grey-text">{list?.length} Bookings</div>
  //             {/* <div className="grey-text" onClick={() => handlePreviosSevenDaysList()}> {datelable} 7 day's</div> */}
  //             <div className='booking-date-picker'>
  //                 <LocalizationProvider dateAdapter={AdapterDateFns}>
  //                     <DesktopDatePicker
  //                         label="Date"
  //                         inputFormat="MM/dd/yyyy"
  //                         value={dateValue}
  //                         onChange={handleDateChange}
  //                         renderInput={(params) => <TextField {...params}
  //                         onChangeRaw={handleDateChangeRaw}
  //                         />}
  //                     />
  //                 </LocalizationProvider>
  //             </div>

  //         </div>
  //         <div className="ride-list">{nameList}</div>
  //         </>
  //        }
  //         <div className="flex-the-toast">
  //             <div style={{ display: showToast }} className="custom-toast">
  //               {toastMessage}
  //             </div>
  //           </div>
  //         <Drawer
  //             anchor={'bottom'}
  //             open={openModal}
  //             onClose={() => setModal(false)}
  //             PaperProps={{
  //                 style: {
  //                     borderRadius: 0,
  //                 },
  //             }}
  //         >
  //             <div className="bc-modal-container">
  //                 <div className="model-heading-container">
  //                     {modalMsg}
  //                 </div>
  //                 <div className="btn-container">
  //                     <button onClick={() => setModal(false)}
  //                         className="cancel-btn"
  //                     >
  //                         Back
  //                     </button>
  //                     <button onClick={() => handleRide()}
  //                         className="confirm-btn"
  //                     >
  //                         Yes
  //                     </button>
  //                 </div>
  //             </div>
  //         </Drawer>
  //     </div>
  // )
};
export default TdbOpen;
